import React, { useEffect } from "react";
import FuelCompositionForm from "components/FuelCompositionForm/FuelCompositionForm";
import Controls from "components/Controls/Controls";
import TopBar from "components/TopBar/TopBar";
import Container from "@material-ui/core/Container";
import LogBox from "components/LogBox/LogBox";
import TabPanel from "../components/TabPanel/TabPanel";
import DamperPositions from "components/DamperPositions/DamperPositions";

import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { StoreState } from "models";

import { Theme, makeStyles, createStyles } from "@material-ui/core/styles";
import { ValmetGrey14 } from "theme";

import { Switch, Route, useRouteMatch } from "react-router-dom";
import StartupBurnerOverride from "components/StartupBurnerOverride/StartupBurnerOverride";

const localStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainViewContainer: {
      paddingTop: "20px",
    },
    mainContent: {
      display: "flex",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    rightPanel: {
      minWidth: "450px",
      padding: theme.spacing(2),
      borderRadius: "0px 4px 4px 4px",
      border: "1px solid " + ValmetGrey14,
      background: "white",
      boxShadow: "0px 2px 5px 0px rgb(0 0 0 / 5%)",
      [theme.breakpoints.down("sm")]: {
        minWidth: "unset",
      }
    },
    leftPanel: {
      width: "20%",
      height: "500px",
      maxWidth: "320px",
      minWidth: "290px",
      border: "1px solid " + ValmetGrey14,
      borderRadius: "4px",
      marginRight: "20px",
      padding: theme.spacing(2),
      background: "white",
      boxShadow: "0px 2px 5px 0px rgb(0 0 0 / 5%)",
      [theme.breakpoints.down("sm")]: {
        height: "unset",
        width: "unset",
        maxWidth: "unset",
        marginRight: 0,
        padding: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        marginBottom: "20px",
      },
    },
    formContainer: {
      [theme.breakpoints.down("sm")]: {
        marginBottom: "20px",
      },
    },
  }),
);

const MainView = () => {
  const localClasses = localStyles();
  const history = useHistory();
  let { path } = useRouteMatch();

  const isLoggedIn: boolean = useSelector((state: StoreState) => state.login.isLoggedIn);

  useEffect(() => {
    if (!isLoggedIn) {
      window.sessionStorage.clear();
      history.push("/");
    }
  }, [history, isLoggedIn]);

  return (
    <>
      <TopBar></TopBar>
      {isLoggedIn ? (
        <Container className={localClasses.mainViewContainer} maxWidth="xl">
          <main className={localClasses.mainContent}>
            <section className={localClasses.leftPanel}>
              <Controls />
            </section>
            <section>
              <TabPanel />
              <div className={localClasses.rightPanel}>
                <Switch>
                  <Route path={`${path}/fuel-composition`}>
                    <div className={localClasses.formContainer}>
                      <FuelCompositionForm />
                    </div>
                  </Route>
                  <Route path={`${path}/damper-positions`}>
                    <DamperPositions />
                  </Route>
                  <Route path={`${path}/startup-burner-override`}>
                    <StartupBurnerOverride />
                  </Route>
                  <Route path={`${path}/logs`}>
                    <LogBox />
                  </Route>
                </Switch>
              </div>
            </section>
          </main>
        </Container>
      ) : null}
    </>
  );
};

export default MainView;
